import { Suspense } from 'react'
import { useAuthStore } from '@/features/auth/store'
import { TopNav } from '@/shared/components/layout/navigation/top-nav'
import { Spinner } from '@/shared/components/spinner'
import { ContactSupportPage } from './lazy-pages'

export function PageSpinner() {
  return (
    <div className="flex h-full items-center justify-center">
      <Spinner />
    </div>
  )
}

export function ContactSupportSuspense() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  return (
    <Suspense
      fallback={
        <div className="flex h-full flex-col bg-white">
          {isAuthenticated && (
            <div className="hidden lg:block">
              <TopNav />
            </div>
          )}
          <PageSpinner />
        </div>
      }
    >
      <ContactSupportPage />
    </Suspense>
  )
}
